import { render, staticRenderFns } from "./AgentLevel.vue?vue&type=template&id=f56891ea&scoped=true"
import script from "./AgentLevel.vue?vue&type=script&lang=js"
export * from "./AgentLevel.vue?vue&type=script&lang=js"
import style0 from "./AgentLevel.vue?vue&type=style&index=0&id=f56891ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56891ea",
  null
  
)

export default component.exports